import styled from 'styled-components';
import Colors from '../../constants/Colors';
import { FontWeight, Text } from '../Text';
import { Breakpoints } from '../../constants/Breakpoints';

export const Container = styled.div`
  width: 430px;
  min-height: ${({ hide }) => hide ? '50px' : '120px'};

  `;
export const ExportBox = styled.div`
  width: 430px;
  min-height: ${({ hide }) => hide ? '50px' : '120px'};
  position:fixed;
  bottom:50px; 
  right:20px;
  background-color:rgb(240, 240, 240);
  border: 1px solid rgb(160, 160, 160);
  border-radius: 5px;
    z-index: 999999;

  @media screen and (max-width: ${Breakpoints.xs}) {
    bottom:0; 
    right:0;
    }
  `;
export const ContainerTitle = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
margin: 10px;

`;
export const ContainerMessage = styled.div`
display: flex;
justify-content: center;
align-items: center;
margin: 10px;

`;
export const Line = styled.hr`
  background-color: rgb(200, 200, 200);

`;
export const TitleExport = styled.div`
font-size: 16px;

`;
export const Close = styled.div`
font-size: 16px;
display:flex;
justify-content: center;
align-items: center;
`;
export const IconStatus = styled.div`
display: flex;
/* justify-content: space-between; */
align-items: center;
`;
export const TextIcon = styled.div`
margin-left: 10px;
`;
export const TextIconClose = styled.div`
margin-left: 10px;
cursor: pointer;
margin-top: 5px;
`;
export const MessageFile = styled.div`
width: 15%;
display: flex;
justify-content: center;
align-items: center;
svg{
  max-width: 60% !important;
}

`;
export const MessageName = styled.div`
display: flex;
flex-direction: column;
svg{
  max-width: 10% !important;
}

`;
export const MessageItem = styled.div`
display: flex;
margin: 10px 10px;
svg{
  max-width: 5% !important;
  margin: 0 10px;
}

`;
export const NameFile = styled.div`
width: 85%;
font-weight: 700;
font-size: 18px;
`;

